<template>
	<div class="majorInfo">
		<div class="major-top">
			<p class="major-top-tit flex zhong">{{ detail.Name }}<i class="shivideo" @click="goVideo"></i></p>
			<p class="major-top-txt" style="margin-top: 10px;">国际代码{{ detail.InternationalCode }}(不可用于填报)</p>
		</div>
		<div class="major-content">
			<div class="mj-con-tit flex">
				<p :class="isTab == 0 ? 'on' : ''" @click="onTab(0)">专业概况</p>
				<p :class="isTab == 1 ? 'on' : ''" @click="onTab(1)">开设院校</p>
			</div>
			<article class="major-div" v-if="isTab == 0">
				<!-- 专业概况 -->
				<div class="major-list">
					<div class="mj-tab">专业概况</div>
					<ul class="mj-gk flex zhong">
						<li>
							<img src="../../../image/zy_a.png" />
							<div class="gk-con">
								<p class="gk-ctxt01">{{ detail.EducationLevel }}</p>
								<p class="gk-ctxt02">学历层次</p>
							</div>
						</li>
						<li>
							<img src="../../../image/zy_b.png" />
							<div class="gk-con">
								<p class="gk-ctxt01">{{ detail.StudyYears }}年</p>
								<p class="gk-ctxt02">修业年限</p>
							</div>
						</li>
						<li>
							<img src="../../../image/zy_c.png" />
							<div class="gk-con">
								<p class="gk-ctxt01">{{ detail.AwardDegree }}</p>
								<p class="gk-ctxt02">授予学位</p>
							</div>
						</li>
						<li>
							<img src="../../../image/zy_d.png" />
							<div class="gk-con">
								<p class="gk-ctxt01">{{ detail.Percent1 }}</p>
								<p class="gk-ctxt02">文理比例</p>
							</div>
						</li>
						<li>
							<img src="../../../image/zy_e.png" />
							<div class="gk-con">
								<p class="gk-ctxt01">{{ detail.Percent2 }}</p>
								<p class="gk-ctxt02">男女比例</p>
							</div>
						</li>
					</ul>
				</div>
				<!-- 专业介绍 -->
				<div class="major-list">
					<div class="mj-tab">专业介绍</div>
					<ul class="mj-jies">
						<li>
							<p class="jies-ctit">专业简介</p>
							<div class="jies-ctxt">
								{{ detail.Introduce }}
							</div>
						</li>
						<li>
							<p class="jies-ctit">培养目标</p>
							<div class="jies-ctxt">
								{{ detail.TrainingObjectives }}
							</div>
						</li>
						<li>
							<p class="jies-ctit">培养要求</p>
							<div class="jies-ctxt">
								{{ detail.TrainingRequirements }}
							</div>
						</li>
						<li>
							<p class="jies-ctit">学科要求</p>
							<div class="jies-ctxt">
								{{ detail.SubjectRequirements }}
							</div>
						</li>
						<li>
							<p class="jies-ctit">知识能力</p>
							<div class="jies-ctxt">
								{{ detail.Knowledge }}
							</div>
						</li>
					</ul>
				</div>
				<!-- 考研方向 -->
				<div class="major-list">
					<div class="mj-tab">考研方向</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.Direction1 }}</div>
					</div>
				</div>
				<!-- 主要课程 -->
				<div class="major-list">
					<div class="mj-tab">主要课程</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.MainCourse }}</div>
					</div>
				</div>
				<!-- 就业方向 -->
				<div class="major-list">
					<div class="mj-tab">就业方向</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.Direction2 }}</div>
					</div>
				</div>
				<!-- 社会名人 -->
				<div class="major-list">
					<div class="mj-tab">社会名人</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.SocietyName }}</div>
					</div>
				</div>
				<!-- 培养目标
                <div class="major-list">
                    <div class="mj-tab">培养目标</div>
                    <div class="mj-jies">
                        <div class="jies-ctxt">{{ detail.Target }}</div>
                    </div>
                </div>培养要求<div class="major-list">
                    <div class="mj-tab">培养要求</div>
                    <div class="mj-jies">
                        <div class="jies-ctxt">{{ detail.Requirement }}</div>
                    </div>
                </div>-->

				<!-- 22.2.15 -->
				<!-- 第一印象 -->
				<div class="major-list">
					<div class="mj-tab">第一印象</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.FirstImpression }}</div>
					</div>
				</div>

				<!-- 选科学科建议 -->
				<div class="major-list">
					<div class="mj-tab">选科学科建议</div>
					<div class="mj-jies">
						<div class="jies-ctxt">{{ detail.Suggestion }}</div>
					</div>
				</div>
				<!-- 近10年平均薪资 -->
				<div class="major-list">
					<div class="mj-tab">近10年平均薪资</div>
					<div class="mj-jies ">
						<div class="mj_lefta">
							<!-- <p>平均薪资：￥7.5k</p> -->
						</div>
						<div class="aimgbox">
							<img :src="detail.PictureUrl1" />
						</div>
					</div>
				</div>
				<!-- 主要职业发布 -->
				<div class="major-list flexFloat">
					<div class="zhi_aa">
						<div class="mj-tab">主要职业发布</div>
						<img :src="detail.PictureUrl2" />
					</div>
					<div class="zhi_aa">
						<div class="mj-tab">主要行业分布</div>
						<img :src="detail.PictureUrl3" />
					</div>
					<div class="zhi_aa">
						<div class="mj-tab">主要就业地区分布</div>
						<img :src="detail.PictureUrl4" />
					</div>
				</div>
			</article>
			<article v-if="isTab == 1" style="padding: 70px 0;">
				<div class="fen_view">
					<ul>
						<li>
							<div class="flex zhong fen_dan">
								<div class="dan_kuan">
									<el-select v-model="timeValue" placeholder="日期" @change="changetimeValue">
										<el-option v-for="item in timeOption" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</div>
								<div class="dan_kuan">
									<el-select v-model="avalue" placeholder="文科或选历史" @change="changeAvalue">
										<el-option v-for="item in aoptions" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</div>
								<div class="dan_kuan">
									<el-select v-model="bvalue" placeholder="本科批" @change="changeBvalue">
										<el-option v-for="item in boptions" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="tian_biao">
								<div class="tian_head biao_two flex">
									<div class="tian_one">院校名称</div>
									<div class="tian_one">院校代码</div>
									<div class="tian_one">计划数</div>
									<div class="tian_one">首选科目</div>
									<div class="tian_one">选科科目</div>
									<div class="tian_one">学制</div>
									<div class="tian_one">学费</div>
								</div>
								<div class="tian_head biao_two biao_two_color biao_one_bg flex"
									v-for="(item, index) in oneList" :key="index">
									<div class="tian_one flexCenter">
										<p>{{item.CollegesName}}</p>
									</div>
									<div class="tian_one">{{item.CollegesCode}}</div>
									<div class="tian_one">{{item.Plan}}</div>
									<div class="tian_one">{{item.PreferredSubject}}</div>
									<div class="tian_one">{{item.RequirementsSubjects}}</div>
									<div class="tian_one">{{item.Educational}}</div>
									<div class="tian_one">{{item.Tuition}}</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</article>
		</div>
		<!-- <div class="popup flexCenter" v-if="isVideoPop">
			<div class="ptbai">
				<video :src="detail.VideoUrl" controls class="videobox"></video>
				<div class="flexCenter">
					<el-button type="primary" @click="isVideoPop=false">关闭</el-button>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isVideoPop: false,
				isTab: 0,
				// 招生计划
				boptions: [],
				bvalue: '',
				bFvalue: '',
				oneList: [],
				// 以上22.2.15
				jiesList: [],
				detailId: 0,
				detail: {},
				aoptions: [],
				avalue: '',
				timeValue: '',
				timeOption: []
			};
		},
		mounted: function() {
			var that = this;
			console.log('页面传参' + that.$route.query);
			that.detailId = that.$route.query.Id ? that.$route.query.Id : '';
			that.GetDetail();
			// that.drawLine();
		},
		methods: {
			goVideo() {
				if (!this.detail.VideoUrl) {
					this.$util.showMsg(false, '请上传专业视频');
					return;
				}
				window.open(this.detail.VideoUrl);
			},
			// drawLine() {
			// 	// 基于准备好的dom，初始化echarts实例
			// 	const myChart = this.$echarts.init(document.getElementById('myChart'));
			// 	// 绘制图表
			// 	myChart.setOption({
			// 		xAxis: {
			// 			type: 'category',
			// 			data: ['2013', '2014', '2017', '2019', '2022']
			// 		},
			// 		yAxis: {
			// 			type: 'value'
			// 		},
			// 		series: [{
			// 			data: [150, 230, 224, 218, 135],
			// 			type: 'line'
			// 		}]
			// 	});
			// },
			onTab(index) {
				this.isTab = index;
			},
			changetimeValue(e) {
				this.RecentlyEnrollmentPlan();
			},
			changeAvalue(e) {
				console.log('2222', e);
				this.RecentlyEnrollmentPlan();
			},
			changeBvalue() {
				this.RecentlyEnrollmentPlan();
			},

			// 22.2.16
			// 获取专业详情
			GetDetail: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetMajorIntroductionDetail?id=' + that.detailId,
					'GET', {},
					function(res) {
						console.log('获取专业详情');
						if (res.code === 0) {
							that.detail = res.data;
							that.timeOption = res.list1;
							if (that.timeOption && that.timeOption.length > 0) {
								that.timeValue = that.timeOption[0];
							}
							that.aoptions = res.list2;
							if (that.aoptions && that.aoptions.length > 0) {
								that.avalue = that.aoptions[0];
							}
							that.boptions = res.list3;
							if (that.boptions && that.boptions.length > 0) {
								that.bvalue = that.boptions[0];
							}
							that.$nextTick(() => {
								that.RecentlyEnrollmentPlan();
							});
						}
					},
					function(res) {}
				);
			},
			RecentlyEnrollmentPlan() {
				var that = this;
				console.log('that.timeValue', that.timeValue);
				console.log('that.avalue', that.avalue);
				console.log('that.bvalue', that.bvalue);
				that.$api.HtppRequest(
					'WebsiteSet/GetCollegeByProfessId?Id=' + that.detailId + '&Year=' + that
					.timeValue + '&CandidatesType=' + that.avalue + '&AdmissionBatch=' + that.bvalue,
					'GET', {},
					function(res) {
						console.log('获取专业分数');
						console.log(res);
						if (res.code === 0) {
							that.oneList = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			}
		}
	};
</script>

<style scoped>
	.tian_one {
		border-right: solid 1px #eeeeee;
	}

	.biao_three .tian_one {
		width: 25% !important;
	}

	.tian_one:last-child {
		border-right: none;
	}

	/deep/.el-date-editor {
		width: 100% !important;
	}

	.dan_kuan {
		width: 150px;
		margin-right: 20px;
	}

	.biao_two .tian_one {
		width: 160px;
	}

	.fen_dan {
		padding-bottom: 20px;
	}

	.tian_one>p {
		line-height: initial;
		max-width: 90%;
		text-align: center;
	}

	.tian_one i {
		width: 24px;
		height: 16px;
		display: inline-block;
		background: url(../../../image/qc.png) no-repeat left top;
		background-size: 100% 100%;
		cursor: pointer;
		margin-left: 12px;
	}

	.fen_view li:first {
		padding-top: 0px;
	}

	.fen_view li {
		padding-top: 5px;
	}

	.tian_biao>p {
		line-height: 36px;
		text-align: center;
		background-color: #dadada;
		color: #000;
		font-size: 14px;
		border: solid 1px #eeeeee;
	}

	.two_btn p::after {
		content: '';
		width: 100%;
		height: 1px;
		position: absolute;
		left: 0;
		bottom: 17px;
		margin-bottom: 0;
		z-index: 1;
		background-color: #a6a6a6;
	}

	.two_btn p {
		color: #000000;
		margin: 0 20px;
		position: relative;
		cursor: pointer;
	}

	.biao_two_color .tian_one {
		font-size: 14px;
		color: #666666;
	}

	.biao_two .tian_one:last-child {
		border-right: none;
	}

	.biao_one_bg {
		background-color: transparent !important;
	}

	.tian_one button {
		font-size: 14px;
		color: #005371;
		width: 80px;
		height: 30px;
		border-radius: 4px;
		line-height: 30px;
		text-align: center;
		border: solid 1px #005371;
		cursor: pointer;
	}

	.biao_one .tian_one:nth-child(2) {
		width: 450px;
		box-sizing: border-box;
		border-left: solid 1px #eeeeee;
		border-right: solid 1px #eeeeee;
	}

	.tian_one {
		font-size: 16px;
		color: #333333;
		text-align: center;
	}

	.tian_head {
		height: 60px;
		line-height: 60px;
		background-color: #f5f5f5;
		border-bottom: solid 1px #eeeeee;
	}

	.tian_head:last-child {
		border-bottom: none;
	}

	.tian_biao {
		border: solid 1px #eeeeee;
		margin-top: 18px;
	}

	/* 02 */

	.mj_gao {
		width: 100%;
		height: 250px;
		overflow: hidden;
	}

	.mj_lefta>p {
		padding: 6px 10px;
		border-radius: 4px;
		background-color: #fafafa;
		font-size: 14px;
		color: #666666;
		text-align: center;
		width: fit-content;
	}

	.mj_lefta {
		width: 300px;
	}

	.mj_you_li span {
		font-size: 14px;
		color: #666666;
		display: inline-block;
	}

	.mj_you_li span:nth-child(2) {
		width: 87px;
	}

	.mj_you_li span:first-child {
		width: 50px;
	}

	.mj_you_li span:last-child {
		color: #3cacff;
	}

	.mj_you_li {
		padding: 10px;
		width: 240px;
		border-bottom: solid 1px #fefefe;
	}

	.mj_you_li:nth-of-type(even) {
		margin-left: 80px;
	}

	.mj_you {
		height: fit-content;
		background-color: #fafafa;
		width: 665px;
		padding: 22px 50px;
	}

	.zhi_aa {
		width: 31%;
	}

	.zhi_aa img {
		display: block;
		max-width: 100%;
	}

	.majorInfo {
		width: 1200px;
		margin: 20px auto;
		background-color: #fff;
		padding: 20px 0;
	}

	/* major-top */
	.major-top {
		width: calc(100% - 40px);
		height: auto;
		background-color: #f5f5f5;
		margin: 0 auto 20px auto;
		padding: 20px 0;
	}

	.major-top-tit {
		font-size: 20px;
		color: #333;
		font-weight: bold;
		padding-left: 30px;
	}

	.major-top-txt {
		padding-left: 30px;
		font-size: 14px;
		color: #666;
	}

	/* major-content */
	.major-content {
		width: calc(100% - 40px);
		margin: 0 auto;
		height: auto;
	}

	.mj-con-tit {
		width: 100%;
		height: auto;
		border-bottom: 2px solid #999;
	}

	.mj-con-tit p.on {
		background-color: #444;
		border: 1px solid #444;
		color: #fff;
	}

	.mj-con-tit p {
		border: 1px solid #999;
		border-bottom: none;
		width: 180px;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		font-size: 16px;
		color: #444;
		text-align: center;
		border-radius: 5px 25px 0 0;
		font-weight: bold;
		cursor: pointer;
	}

	/* major-div */
	.major-div {
		width: 100%;
		height: auto;
	}

	.major-list {
		width: 100%;
		height: auto;
	}

	.mj-tab {
		width: 100%;
		height: auto;
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 15px;
		margin: 30px 0;
	}

	.mj-tab::after {
		position: absolute;
		content: '';
		width: 0;
		height: 18px;
		border: 2px solid #111;
		border-radius: 50px;
		left: 0;
		top: 50%;
		margin-top: -10px;
	}

	/* mj-gk */
	.mj-gk {
		width: 100%;
	}

	.mj-gk li {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20%;
	}

	.mj-gk li>img {
		width: 40px;
		height: 40px;
		display: block;
		margin-right: 10px;
	}

	.gk-ctxt01 {
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}

	.gk-ctxt02 {
		font-size: 14px;
		color: #666;
	}

	/* mj-jies */
	.mj-jies {
		width: 100%;
		padding: 0 15px;
		height: auto;
	}

	.mj-jies li {
		width: 100%;
		height: auto;
		margin-bottom: 20px;
	}

	.jies-ctit {
		width: 135px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #333;
		text-align: center;
		background-color: #f5f5f5;
		margin-bottom: 10px;
	}

	.jies-ctxt {
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
		font-size: 14px;
		color: #666;
	}

	.aimgbox {
		margin-top: 20px;
	}

	.aimgbox img {
		display: block;
		width: 100%;
	}

	.shivideo {
		width: 32px;
		height: 32px;
		background: url(../../../image/bhb.png) no-repeat left top;
		background-size: 100% 100%;
		margin-left: 20px;
		cursor: pointer;
	}

	.ptbai {
		width: 1100px;
		background-color: #fff;
		border-radius: 20px;
		padding: 30px 30px 50px 30px;
	}

	.videobox {
		margin-bottom: 50px;
		width: 100%;
		height: 520px;
		display: block;
	}
</style>
